import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    searchInput: {
        key: "",
        value: ""
    },
}
const mutations = {
    mutationsChangeInput(state, payload) {
        let data = Object.assign({}, state.searchInput, payload);
        // 将state.personInfo指向新对象的引用地址
        state.searchInput = data;
    },
}
export default new Vuex.Store({
    state,
    mutations
})


// WEBPACK FOOTER //
// ./src/store.js